import { useEffect, useState } from "react"
import { RenderInput, Unit } from "../types"
import { Plugin } from "./types"
import { HugoEventType, soundboard } from "../.."

type PluginProps = {
    label: string,
    onClick: (event: CustomEvent) => void,
    position: { x: number, y: number },
    visible: boolean,
    condensed?: boolean,
}

const getRange = (label: string, position: { x: number, y: number }, condensed: boolean) => ({
    x1: position.x,
    x2: position.x + label.length + (condensed ? 3 : 5),
    y1: position.y,
    y2: position.y + 2,
})

const applyBorder = (input: Unit[][], label: string, position: { x: number, y: number }, condensed: boolean): RenderInput => {
    let returnInput: RenderInput = [...input]
    const labelChars = label.split('')
    const range = getRange(label, position, condensed)

    for (let yIterator = 0; yIterator <= range.y2; yIterator++) {
        if (!Array.isArray(returnInput[yIterator])) {
            returnInput[yIterator] = []
        }
    }

    for (let yIterator = range.y1; yIterator <= range.y2; yIterator++) {


        for (let xIterator = range.x1; xIterator <= range.x2; xIterator++) {
            if (returnInput[yIterator].length < range.x1) {
                returnInput[yIterator] = [...returnInput[yIterator], ...Array(range.x1 - returnInput[yIterator].length).fill(' ')]
            }

            switch (true) {
                case (typeof returnInput[yIterator] === 'undefined' || !Array.isArray(returnInput[yIterator])):
                    break;
                // Top Left
                case xIterator === range.x1 && yIterator === range.y1:
                    returnInput[yIterator][xIterator] = '┌'
                    break;
                // Top Right
                case xIterator === range.x2 && yIterator === range.y1:
                    returnInput[yIterator][xIterator] = '╖'
                    break;
                // Bottom Left
                case xIterator === range.x1 && yIterator === range.y2:
                    returnInput[yIterator][xIterator] = '╘'
                    break;
                // Bottom Right
                case xIterator === range.x2 && yIterator === range.y2:
                    returnInput[yIterator][xIterator] = '╝'
                    break;
                // Top & Buttom
                case yIterator === range.y1:
                    returnInput[yIterator][xIterator] = '─'
                    break;
                case yIterator === range.y2:
                    returnInput[yIterator][xIterator] = '═'
                    break;
                // Left & Right
                case xIterator === range.x1:               
                    returnInput[yIterator][xIterator] = '│'
                    break;
                case xIterator === range.x2:
                    returnInput[yIterator][xIterator] = '║'
                    break;
                // Label & Spaces
                default:
                    returnInput[yIterator][xIterator] = labelChars[xIterator - range.x1 - (condensed ? 2 : 3)] || " ";
                    break;

            }
        }
    }

    return returnInput
}

const useButton = ({ label, position, visible, onClick, condensed = false }: PluginProps): [Plugin] => {


    useEffect(() => {
        const handler = (event: Event) => {
            if (!visible) return
            const range = getRange(label, position, condensed)

            if (
                (event as CustomEvent).detail.position.x >= range.x1
                && (event as CustomEvent).detail.position.x <= range.x2
                && (event as CustomEvent).detail.position.y >= range.y1
                && (event as CustomEvent).detail.position.y <= range.y2
            ) {
                onClick(event as CustomEvent)
            }
        }
        document.addEventListener(HugoEventType.OnClick, handler)

        return () => {
            document.removeEventListener(HugoEventType.OnClick, handler)
        }
    }, [onClick])

    const plugin: Plugin = (input, tick, resolution) => {
        return applyBorder(input, label, position, condensed)
    }

    return [plugin]
}

export default useButton
